/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StarPickerContainer = styled.div`
  min-width: 232px;

  .StarPickerButton {
    line-height: 52px;
    margin-right: 5px;
    cursor: default;

    .DefaultStarComponent.selected {
      color: #ffca43;
    }

    &.halfStars:nth-child(2n + 1) {
      margin-left: 0;
    }

    &.halfStars:nth-child(2n) {
      margin-right: 8px;
    }

    &.halfStars:last-child {
      margin-right: 0;
    }
  }

  @media (max-width: 575px) {
    min-width: 0px;
    .StarPickerButton {
      font-size: 28px;
    }
    .StarPickerButton.halfStars {
      width: 14px;
    }
    .StarPickerButtonContent.halfStars {
      width: 28px;
    }
    .hero-social-proof--rate-description {
      font-size: var(--font-size-p-sm);
    }
    .StarPickerButton {
      &.halfStars:nth-child(2n) {
        margin-right: 5px;
      }
    }
  }
`;
